const getApiUrl = () => {
  if (import.meta.env.VITE_UI_API_OVERRIDE) {
    return import.meta.env.VITE_UI_API_OVERRIDE.trim()
  }

  return (window as any)["runConfig"].apiUrl
}

console.log(`API URL: ${getApiUrl()}`)

export const cachingEnabled = true
export const apiUrl = getApiUrl()

// Widget assets are vendored into public/webcomponents at build time (see the
// vendor-web-components plugin in vite.config.js) so they load same-origin under
// `script-src 'self'`. Embed snippets are pasted into third-party pages, so those
// need absolute URLs.
export const webComponentScriptUrl = "/webcomponents/main.js"
export const webComponentStyleUrl = "/webcomponents/main.css"
export const webComponentEmbedScriptUrl = `${window.location.origin}${webComponentScriptUrl}`
export const webComponentEmbedStyleUrl = `${window.location.origin}${webComponentStyleUrl}`
